export const soundPlayer = path => {
    return new Audio(path)
}